// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".XL{width:135px;height:100px}.Large{width:100px;height:100px}.Medium{width:75px;height:75px;min-width:75px}.Small{width:50px;height:50px}.Small-challenge{width:37px;height:37px}.Small-Header{width:50px;height:50px;margin-left:10px}.XS{width:34px;height:34px}.avatar{overflow:hidden;max-width:100%;border-radius:100%}.rounded-image{width:100%;height:100%;border-radius:100%}\n", ""]);
// Exports
module.exports = exports;
